/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import axios from 'axios';
import urlJoin from 'proper-url-join';

import { GetInstanceQueryParam, InstanceData } from '../../../../ts/instance';
import {
  InstancePreferences,
  UserPreferences
} from '../../../../ts/preferences';
import { endpoints } from '../../util/config';

const internalInstanceEndpoint = urlJoin(endpoints.store, '/instance');

const instancePreferencesEndpoint = urlJoin(
  endpoints.store,
  'preferences',
  'instance'
);

export const getInstance = async (search?: string): Promise<InstanceData> => {
  let forceClassic: boolean;

  if (search) {
    const searchParams = new URLSearchParams(search);
    forceClassic = searchParams.has(GetInstanceQueryParam.FORCE_CLASSIC);
  }

  const url = forceClassic
    ? `${internalInstanceEndpoint}?${GetInstanceQueryParam.FORCE_CLASSIC}=true`
    : internalInstanceEndpoint;

  const response = await axios.get(url);
  return response.data;
};

export const postInstance = async (
  data: Pick<InstanceData, 'tooling_data'>
): Promise<void> => {
  const response = await axios.post(internalInstanceEndpoint, data);
  return response.data;
};

export const setUserPreferences = async (data: {
  preferences: UserPreferences;
}) => {
  const url = urlJoin(endpoints.store, 'preferences/user');
  const response = await axios.post(url, data);
  return response.data;
};

export const setInstancePreferences = async (data: {
  preferences: InstancePreferences;
}) => {
  const response = await axios.post(instancePreferencesEndpoint, data);
  return response.data;
};
